import { FormAlert } from '@frontend/jetlend-web-ui/src/ui/forms/FormAlert/FormAlert';
import PropertyItem from '@frontend/jetlend-web-ui/src/components/PropertyItem/PropertyItem';
import {
    formatAmountShort,
    formatPercentExt,
} from '@frontend/jetlend-core/src/formatters/formatUtils';
import { numWordForm } from '@frontend/jetlend-core/src/utils/langUtils';
import Button from '@frontend/jetlend-web-ui/src/ui/inputs/Button/Button';
import styles from './ScoringSuccess.module.scss';

export interface Props {
    /**
     * Максимальный лимит
     */
    limit: number;
    /**
     * Процентная ставка
     */
    rate: number;
    /**
     * Срок в месяцах
     */
    term: number;
    /**
     * Ссылка на визард
     */
    url: string;
}

/**
 * Компонент для отображения успешного результата скоринга
 */
export default function ScoringSuccess({
    limit,
    rate,
    term,
    url,
}: Props) {
    return (
        <div className={styles['content']}>
            <h2 className={styles['title']} data-testid="limit-prescoring-modal__title">
                Возобновляемая линия займа предварительно одобрена
            </h2>
            <FormAlert
                alert="Открытие ВЛЗ не приводит к выборке транша, не передает никакие данные в БКИ, а также ни к чему не обязывает"
                type="success"
            />

            <div className={styles['property-items-container']}>
                <PropertyItem
                    title="Максимальный лимит"
                    value={<span className={styles['text-amount']}>{formatAmountShort(limit)}</span>}
                    align="left"
                    className={styles['property-item']}
                    valueClassName={styles['property-item--value']}
                    titleClassName={styles['property-item--title']}
                />

                <PropertyItem
                    title="Срок действия линии"
                    value={numWordForm(term, 'month', '-')}
                    align="left"
                    className={styles['property-item']}
                    valueClassName={styles['property-item--value']}
                    titleClassName={styles['property-item--title']}
                />

                <PropertyItem
                    title="Ставка"
                    value={formatPercentExt(rate)}
                    align="left"
                    className={styles['property-item']}
                    valueClassName={styles['property-item--value']}
                    titleClassName={styles['property-item--title']}
                />
            </div>

            <Button
                containerClassName={styles['button-container']}
                className={styles['button']}
                size="big"
                href={url}
            >
                Продолжить
            </Button>
        </div>
    );
}